import React, {useEffect, useState} from "react";
import FilteringAccordionItem from "../../atoms/filtering-accordion-item/filtering-accordion-item";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../store/configureStore";
import {clubFinderSearchBarSliceActions} from "../../../../store/slices/clubFinderSearchBarSlice";

const InclusionFilterComponent = (props: any): JSX.Element => {
  const dispatch = useDispatch();

  const selectedInclusionFilter = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedInclusionFilters);
  const [savedInclusion, setSavedInclusion] = useState([]);

  const handleFilterOption = (inclusionOptions: any) => {
    if (savedInclusion && selectedInclusionFilter) {
      //Local State Change
      const tempSavedInclusion = [...savedInclusion]
      // @ts-ignore
      const index = tempSavedInclusion.indexOf(inclusionOptions.inclusionPlayHQValue);

      if (index !== -1) {
        tempSavedInclusion.splice(index, 1);
        setSavedInclusion([...tempSavedInclusion]);
      } else {
        // @ts-ignore
        tempSavedInclusion.push(inclusionOptions.inclusionPlayHQValue)
        setSavedInclusion([...tempSavedInclusion]);
      }

      //Redux State Change
      const tempSavedInclusionOption = [...selectedInclusionFilter]
      const indexOfSelectInclusionOption = tempSavedInclusionOption.findIndex((item: any) => item.inclusionPlayHQValue === inclusionOptions.inclusionPlayHQValue);
      if (indexOfSelectInclusionOption !== -1) {
        tempSavedInclusionOption.splice(index, 1);
        dispatch(clubFinderSearchBarSliceActions.setSavedInclusionFilter([...tempSavedInclusionOption]))
      } else {
        tempSavedInclusionOption.push(inclusionOptions);
        dispatch(clubFinderSearchBarSliceActions.setSavedInclusionFilter([...tempSavedInclusionOption]))
      }
    } else {
      // @ts-ignore
      setSavedInclusion([inclusionOptions.inclusionPlayHQValue]);
      dispatch(clubFinderSearchBarSliceActions.setSavedInclusionFilter([inclusionOptions]))
    }
  }

  useEffect(() => {
    if (selectedInclusionFilter == null) {
      setSavedInclusion([])
    } else {
      const inclusionValues = selectedInclusionFilter.map((item: any) => item.inclusionPlayHQValue);
      setSavedInclusion(inclusionValues);
    }
  },[selectedInclusionFilter])

  return (
    <FilteringAccordionItem accordionTitle={'Inclusion'} filterOption={props.inclusionFilterOptions}
                            filterType={'inclusions'} key={'inclusions'}
                            handleFilterOption={(inclusionOptions: any) => handleFilterOption(inclusionOptions)} savedInclusion={savedInclusion}/>
  )
}

export default InclusionFilterComponent;
